import React from "react";
import { BsInstagram } from "react-icons/bs";
import { ImGithub } from "react-icons/im";
import { BsLinkedin } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import memoji from '../assets/Memoji.jpg';
import '../styles/Card.scss';
import Typical from "react-typical";


function Card() {
  return (
    <div className="card">
      <div className="cardBody">
        <div className="cardHeader textCenter">
          <img src={memoji} className="profile" alt="Memoji"/>
          <div className="cardHeaderContent">
            <h1>@marcelkhan</h1>
            <p>Hello, I'm</p>
            <h2>Marcel Khan</h2>
            <p>
              And I'm a{' '}
              <Typical
                loop={Infinity}
                wrapper="b"
                steps={['', 2000, 'Developer 💻', 2000, 'Designer 🎨', 2000, 'Student 🤓', 2000]}
              />
            </p>
          </div>
        </div>

        <div className="cardContent">
          <a className="btnAction" href="https://github.com/marcelkhan">
            <ImGithub />
            <span>Github</span>
          </a>
        </div>

        <div className="cardContent">
          <a className="btnAction" href="/some-url">
            <FaUser />
            <span>My Website</span>
          </a>
        </div>

        <div className="cardContent">
          <a className="btnAction" href="https://www.linkedin.com/in/marcel-khan-3b569b226/">
            <BsLinkedin />
            <span>Linkedin</span>
          </a>
        </div>

        {/* <div className="cardContent">
          <a className="btnAction" href="https://www.instagram.com/marcel.k99/">
            <BsInstagram />
            <span>Instagram</span>
          </a>
        </div> */}

      </div>
    </div>
  );
}

export default Card;